import { getBranchStocksDetail } from '../../services/api/branchStock.api';
import { GET_BRANCHES_SINGLE_REQUEST, GET_BRANCHES_SINGLE_SUCCESS, GET_BRANCHES_SINGLE_FAILURE } from '../types';
import { transformStockBranchesDetail } from '../../transforms/stock';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockBranchesDetail({}),
	},

	mutations: {
		[GET_BRANCHES_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_BRANCHES_SINGLE_SUCCESS](state, { data }) {
			state.isLoading = false;
			state.data = transformStockBranchesDetail(data);
		},
		[GET_BRANCHES_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranchStocksDetail({ commit }, { id = null }) {
			try {
				commit(GET_BRANCHES_SINGLE_REQUEST);
				const { data } = await getBranchStocksDetail(id);
				commit(GET_BRANCHES_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCHES_SINGLE_FAILURE, error);
			}
		},
	},
};